var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 61,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#warning_svg__a)",
    fillRule: "evenodd",
    d: "M11.706 25.883C21.434 8.636 26.298.012 34 .012c7.703 0 12.566 8.624 22.294 25.871l1.213 2.15c8.083 14.332 12.125 21.499 8.472 26.739s-12.69 5.24-30.767 5.24h-2.424c-18.076 0-27.114 0-30.767-5.24s.389-12.407 8.473-26.74zM34 14.178a2.5 2.5 0 0 1 2.5 2.5v16.667a2.5 2.5 0 0 1-5 0V16.678a2.5 2.5 0 0 1 2.5-2.5m0 32.5a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "warning_svg__a",
    x1: 31.506,
    x2: -19.838,
    y1: 75.012,
    y2: 52.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9737"
  })))));
};
export default SvgWarning;